function ConfirmationModal({ date, onConfirm, onCancel, isCompleting }) {
    const formattedDate = new Date(date + 'T00:00:00').toLocaleDateString('en-US', { 
        month: 'long', 
        day: 'numeric', 
        year: 'numeric' 
    }).toUpperCase();

    return (
        <div className="modal-overlay tw-z-[1002]">
            <div className="modal-container tw-items-center tw-text-center" onClick={(e) => e.stopPropagation()}>
                <button 
                    onClick={onCancel}
                    className="tw-absolute tw-top-6 tw-right-6 tw-bg-transparent tw-border-0 tw-text-5xl tw-cursor-pointer tw-text-gray-400 hover:tw-text-black"
                >
                    ×
                </button>

                <h1 
                    className="tw-m-0 tw-mb-8"
                    style={{
                        color: '#000',
                        textAlign: 'center',
                        fontFamily: 'Poppins',
                        fontSize: '32px',
                        fontStyle: 'normal',
                        fontWeight: 700,
                        lineHeight: '110%',
                        textTransform: 'uppercase'
                    }}
                >
                    {formattedDate}
                </h1>
                
                <p 
                    className="tw-m-0 tw-mb-8"
                    style={{
                        color: '#414042',
                        textAlign: 'center',
                        fontFamily: 'Poppins',
                        fontSize: '24px',
                        fontStyle: 'normal',
                        fontWeight: 600,
                        lineHeight: '100%'
                    }}
                >
                    Don't cheat yourself. Did you really complete your workout this day?
                </p>

                <img
                    src="https://cdn.shopify.com/s/files/1/0667/9599/5332/files/new-modal-complete.png?v=1767205316"
                    alt="Workout"
                    className="tw-w-full tw-max-w-[500px] tw-h-auto tw-object-contain tw-rounded-lg tw-mb-8"
                />
                
                <button 
                    onClick={onConfirm}
                    disabled={isCompleting}
                    className="btn-primary tw-mb-4"
                >
                    {isCompleting ? 'COMPLETING...' : 'YES! I PROMISE'}
                </button>
                
                <button 
                    onClick={onCancel}
                    disabled={isCompleting}
                    className="btn-secondary"
                >
                    NOT YET
                </button>
            </div>
        </div>
    );
}

export default ConfirmationModal;
